import clarity from "@microsoft/clarity"

const initClarity = () => {
  const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID

  if (projectId) {
    clarity.init(projectId)
    console.log(
      "Microsoft Clarity initialized successfully with project ID:",
      projectId
    )
  } else {
    console.warn(
      "Microsoft Clarity project ID not found in environment variables"
    )
  }
}

export { initClarity }
